import { MenuItem, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import SvgIconStyle from 'src/components/SvgIconStyle';
import CareCircleTerms from 'src/dialogs/carecircle/CareCircleTermsDialog';
import JoinCareCircleDialog from 'src/dialogs/carecircle/JoinCareCircleDialog';
import useCCReferral from 'src/hooks/useCCReferral';
import useLocales from 'src/hooks/useLocales';
import { PATH_MAIN } from 'src/routes/paths';

export default function CareCircleNav() {
    const { translate } = useLocales();
    const { careCircleStatus, statusLoading } = useCCReferral({
        queriesToRun: ['GET_CARE_CIRCLE_STATUS'],
    });

    const [openDialog, setOpenDialog] = useState(false);
    const [openTermsDialog, setOpenTermsDialog] = useState(false);

    const navigate = useNavigate();

    const handleCloseDialog = useCallback(() => {
        setOpenDialog(false);
    }, []);

    const handleToggleTermsDialog = useCallback(() => {
        setOpenTermsDialog((prev) => !prev);
    }, []);

    const handleNavigate = useCallback(() => {
        if (statusLoading) return;
        if (careCircleStatus?.enrolled) {
            navigate(PATH_MAIN.general.careCircle);
            return;
        }
        setOpenDialog(true);
    }, [careCircleStatus?.enrolled, navigate, statusLoading]);

    return (
        <>
            <MenuItem
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    columnGap: 1,
                    px: 1,
                    py: 0.75,
                }}
                onClick={handleNavigate}
                disabled={statusLoading}
            >
                <SvgIconStyle
                    src="/assets/icons/navbar/cc-nav-icon.svg"
                    sx={{ width: 20, height: 20, color: 'text.primary' }}
                />
                <Typography variant="body2">{translate('components.careCircle.nav')}</Typography>
            </MenuItem>
            <JoinCareCircleDialog
                open={openDialog}
                onClose={handleCloseDialog}
                onOpenTerms={handleToggleTermsDialog}
            />
            <CareCircleTerms open={openTermsDialog} onClose={handleToggleTermsDialog} />
        </>
    );
}
